import StatutoryBooks from './container';

export default StatutoryBooks;
